var lcssafira = lcssafira ||  {};
lcssafira.users = lcssafira.users || {};

;(function(namespace, $){

  var Users = function() {

    function CadastraUsuario() {
      var validate_form = new lcssafira.form.ValidateForm('form-user');
    }

    function _construct() {
      CadastraUsuario();
      swithBlockAssinaturas();
      var inputAssinaDocs = $('#input-assina-docs');
      var inputAssinaDocsVal = (inputAssinaDocs.is(':checked')) ? 1 : 0;
      var message = "A remoção de um usuário implica na exclusão de qualquer dado vinculado a ele.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-usuario', message);
      inputAssinaDocs.trigger( "switchChange.bootstrapSwitch", [inputAssinaDocsVal]);
    }

    function swithBlockAssinaturas()
    {
      var rowFileComp = $('#row-file-comp');

      $('#input-assina-docs').on('switchChange.bootstrapSwitch', function(event, state) {
        if(state) {
          rowFileComp.show();
        }
        else {
          rowFileComp.hide();
        }
      });
    }

    _construct();

  };

  var main = new Users();

})(lcssafira.users, jQuery);


